import { History, CreditCard, TrendingUp, BarChart2, Repeat, FileText, Upload, FilePlus, Building2, Users } from 'lucide-react';

const TABS = [
  { id: 'expenses', label: 'Expenses', icon: History },
  { id: 'payments', label: 'Loan/Rent', icon: CreditCard },
  { id: 'income', label: 'Income', icon: TrendingUp },
  { id: 'bank', label: 'Bank', icon: Building2 },
  { id: 'payroll', label: 'Payroll', icon: Users },
  { id: 'create-invoice', label: 'Create Invoice', icon: FilePlus },
  { id: 'analytics', label: 'Analytics', icon: BarChart2 },
  { id: 'tax', label: 'Tax Report', icon: FileText },
  { id: 'recurring', label: 'Recurring', icon: Repeat },
];

function DashboardTabs({ activeTab, onTabChange, invoiceCount, onInvoiceDropClick, showInvoiceDrop }) {
  return (
    <div className="flex items-center gap-2 border-b border-slate-200 dark:border-slate-700 mb-4 overflow-x-auto">
      {/* Invoice Drop - Special prominent tab */}
      <button
        onClick={onInvoiceDropClick}
        className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium rounded-t-lg transition-colors whitespace-nowrap ${
          showInvoiceDrop
            ? 'bg-indigo-600 text-white'
            : 'bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 hover:bg-indigo-100 dark:hover:bg-indigo-900/50'
        }`}
        data-testid="tab-invoice-drop"
      >
        <Upload className="w-4 h-4" />
        <span>Invoice Drop</span>
      </button>

      {/* Divider */}
      <div className="h-6 w-px bg-slate-300 dark:bg-slate-600 mx-1" />

      {/* Other tabs */}
      {TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === tab.id && !showInvoiceDrop
                ? 'border-indigo-600 text-indigo-700 dark:text-indigo-400'
                : 'border-transparent text-slate-500 hover:text-slate-700 dark:text-slate-400'
            }`}
            data-testid={`tab-${tab.id}`}
          >
            <Icon className="w-4 h-4" />
            <span>{tab.label}</span>
            {tab.id === 'expenses' && (
              <span className="text-xs bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                {invoiceCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default DashboardTabs;
